<template>
  <div class="otp" v-on:keyup.enter="sendOtp()">
    <h2 class="fn-title-1 title">Підтвердження заявки</h2>

    <p class="m-body-m message">{{text}}</p>

    <DefaultInput
      name="otp"
      type="number"
      inputmode="numeric"
      label="Код з СМС"
      v-model="otpCode"
      :error="errors.has('otp')"
      v-validate="`length:4|required`"
    />
    <span class="error m-footnote-m" v-if="errors.first('otp')">{{ errors.first('otp') }}</span>

    <div class="buttons">
      <button class="main-btn second-color large-btn" v-on:click="sendOtp()" :disabled="disabledNextBtn">Продовжити</button>
      <button class="second-btn second-color large-btn"
              v-on:click="reSendOtp()"
              :disabled="Boolean(otpCurrentCount)">Повторно запросити {{ otpCurrentCount ? `(${otpCurrentCount} сек)` : '' }}
      </button>
    </div>

    <span class="error error-otp m-footnote-m">{{ OtpErrorMessage }}</span>
  </div>
</template>

<script>
import { HTTP } from '@/httpСommon.js'
import DefaultInput from '@/components/Ui-new/DefaultInput.vue'

export default {
  props: {
    otpState: Boolean,
    text: String,
    otpRef: String
  },
  components: {
    DefaultInput
  },
  data: function () {
    return {
      otpCode: null,
      otpCurrentCount: 60,
      OtpErrorMessage: '',
      disabledNextBtn: false
    }
  },
  watch: {
    otpState: {
      immediate: true,
      handler (val) {
        if (val) {
          this.otpTimer(60)
        }
      }
    }
  },
  methods: {
    otpTimer: function (count) {
      this.otpCurrentCount = 60
      const currentTick = setInterval(() => (this.otpCurrentCount -= 1), 1000)
      setTimeout(() => { clearInterval(currentTick); this.otpCurrentCount = 0 }, count * 1000)
    },
    sendOtp: function () {
      const data = {
        otp_ref: this.otpRef,
        otp_code: this.otpCode
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabledNextBtn = true
          HTTP
            .post('api/v1/questionnaire/otp/confirm', JSON.stringify({ ...data, source: 'LENDING_V.1' }),
              {
                headers: {
                  'content-type': 'application/json',
                  Accept: 'application/json'
                }
              }
            )
            .then(response => {
              this.$router.push(`/${response.data.data.journal_ref}`)
              this.OtpErrorMessage = ''
              this.disabledNextBtn = false
            })
            .catch(err => {
              this.disabledNextBtn = false
              if (err.response.status === 500) {
                this.OtpErrorMessage = 'Виникла помилка'
              } else {
                this.OtpErrorMessage = err.response.data.error.message
              }
            })
        }
      })
    },
    reSendOtp: function () {
      this.otpTimer(60)
      this.otpCode = ''
      this.OtpErrorMessage = ''
      const data = {
        otp_ref: this.otpRef
      }
      HTTP
        .post('api/v1/questionnaire/otp/send', JSON.stringify({ ...data, source: 'LENDING_V.1' }),
          {
            headers: {
              'content-type': 'application/json',
              Accept: 'application/json'
            }
          }
        )
        .then(response => {
        })
        .catch(err => {
          console.log(err)
          this.OtpErrorMessage = 'Виникла помилка під час повторної відправці OTP пароля'
        })
    }
  }
}
</script>

<style lang="less" scoped>
.otp {
  .title {
    margin: 0 0 16px 0;
  }

  .message {
    margin: 0 0 40px 0;
  }

  .buttons {
    margin: 40px 0 0 0;
    display: flex;

    @media (max-width: 480px) {
      flex-direction: column;
    }

    button + button {
      margin: 0 0 0 8px;

      @media (max-width: 480px) {
        margin: 8px 0 0 0;
      }
    }
  }

  .error-otp {
    display: block;
    margin: 4px 0 0 0;
  }
}
</style>
